(() => {
  const pageEntry = {
    init() {
      this.mainContent = document.getElementById('MainContent');

      if (!this.mainContent || document.documentElement.classList.contains('shopify-design-mode')) return;

      this.mainContent.classList.add('main-content-transition');
      document.body.classList.add('page-ready');
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => pageEntry.init());
  } else {
    pageEntry.init();
  }
})();
